import { Component, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { ChangeCurrentClientService } from '../../administration/client/change-current-client/change-current-client.service';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { Client } from '../../../../projects/kiene-core/src/lib/components/client/classes/client';
import { KieneBackendApiService } from '../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import {
    EnterValueInput,
    EnterValueResponse,
} from '../../../../projects/kiene-core/src/lib/components/dialogs/enter-value-dialog/enter-value-response';
import { EnterValueDialogComponent } from '../../../../projects/kiene-core/src/lib/components/dialogs/enter-value-dialog/enter-value-dialog.component';
import { ConfirmDialogComponent } from '../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog.component';
import {
    ConfirmDialogInput,
    ConfirmDialogResult,
} from '../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog';
import { BiosicherheitsplanRindSection1 } from './biosicherheitsplan-rind.models';
import { Inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Tierarzt } from '../../../../projects/kiene-core/src/lib/components/tieraerzte/classes/tierarzt';
import { ChartType } from 'angular-google-charts';
import { HttpErrorResponse } from '@angular/common/http';
import {
    BSP_RIND_SKIP_PLAN_OEFFNEN_KEY,
    bspRindSetSkipPlanOeffnenBestaetigung,
} from './bsp-rind-open-confirm';
import {
    PdfViewerDesktopService,
    PdfViewerDialogInput,
} from '../../../../projects/kiene-core/src/lib/components/pdf-viewer/kiene-pdf-viewer/kiene-pdf-viewer-desktop/pdf-viewer-desktop.service';

@Component({
    selector: 'kiene-bio-sicherheits-plan-rind',
    templateUrl: './bio-sicherheits-plan-rind.component.html',
    styleUrls: ['./bio-sicherheits-plan-rind.component.scss'],
})
export class BioSicherheitsPlanRindComponent implements OnInit, OnDestroy {
    form: FormGroup = this.fb.group({
        besteuerung: [null as 'optierend' | 'pauschal' | null],
        planDatum: [null as Date | null],
        tskNummern: [''],
        registriernummern: [''],
        betrieb: this.createPersonGroup(),
        verantwortlichePerson: this.createPersonGroup(),
        angabenBetrieb: this.fb.group({
            anschriftBetriebsstandortAbweichend: [''],
            anzahlStaelleMitStallbezeichnung: [''],
            anzahlRinderZumZeitpunktBearbeitung: [''],
        }),
        tieraerztlicheBetreuung: this.fb.group({
            name: [''],
            anschrift: [''],
            vvvoNr: [''],
            betreuungsvertrag: [null as boolean | null],
        }),
        tierhaltung: this.fb.group({
            produktionsverfahren: this.fb.group({
                rindermast: [false],
                fresseraufzucht: [false],
                milchmast: [false],
                roesemast: [false],
                mutterkuhhaltung: [false],
                milchviehhaltung: [false],
                jungrinderaufzucht: [false],
                pensionsviehhaltung: [false],
                sonstiges: [false],
                sonstigesText: [''],
            }),
            artWeiseHaltung: this.fb.group({
                reinRaus: [false],
                abteilweiseStallweise: [false],
                kontinuierlich: [false],
                mitLaufhof: [false],
                weidehaltung: [false],
                weidehaltungDetails: [''],
            }),
            zukauf: this.fb.group({
                aktiv: [null as boolean | null],
                anzahlHerkunftsbetriebe: [''],
            }),
            externeJungviehaufzuchtBeiMilchviehhaltung: [null as boolean | null],
            weitereTierhaltungen: this.fb.group({
                gefluegel: [false],
                schafeZiegen: [false],
                schweine: [false],
                sonstigeWiederkaeuer: [false],
                sonstigeWiederkaeuerText: [''],
                andereNutztierarten: [false],
                andereNutztierartenText: [''],
            }),
        }),
        risikofaktorenLage: this.fb.group({
            gelaendelage: this.fb.group({
                innerorts: [false],
                ausserorts: [false],
            }),
            betriebsstaetten: this.fb.group({
                anzahl: [''],
                verbindungenZwischen: [null as boolean | null],
                verbindungen: this.fb.group({
                    tiere: [false],
                    einstreuFuttermittel: [false],
                    betreuungspersonal: [false],
                    betriebsfahrzeuge: [false],
                    geraetschaften: [false],
                    treibwege: [false],
                    sonstige: [false],
                    sonstigeText: [''],
                }),
            }),
            verbindungenAndereBetriebe: this.fb.group({
                vorhanden: [null as boolean | null],
                details: this.fb.group({
                    tiere: [false],
                    einstreuFuttermittel: [false],
                    betreuungspersonal: [false],
                    betriebsfahrzeuge: [false],
                    geraetschaften: [false],
                    treibwege: [false],
                    sonstige: [false],
                    sonstigeText: [''],
                }),
            }),
            betriebsfremdeHaltungenWiederkaeuer500m: this.fb.group({
                bekannt: [null as boolean | null],
                tierart: [''],
            }),
            infektionsquellenUmgebung: this.fb.group({
                schlachthof: [false],
                sammelstelle: [false],
                rindertransportunternehmen: [false],
                sonstige: [false],
                sonstigeText: [''],
            }),
            fremdarbeitskraefte: this.fb.group({
                vorhanden: [null as boolean | null],
                kontaktZuWiederkaeuern: [null as boolean | null],
                kontaktart: [''],
            }),
        }),
        kenntnisseSensibilisierungUnterweisungen: this.fb.group({
            tierhalterUnternehmerPersonal: this.fb.group({
                handlungsbedarf: [null as boolean | null],
                stufe1: [false],
                stufe2: [false],
                stufe3: [false],
                vermittlungKenntnisse: [''],
                dokumentenhinweis: [''],
            }),
            drittePersonenBesucher: this.fb.group({
                handlungsbedarf: [null as boolean | null],
                stufe1: [false],
                stufe2: [false],
                stufe3: [false],
                sicherstellungZutrittUnterweisung: [''],
                dokumentenhinweis: [''],
            }),
        }),
        baulicheGegebenheiten: this.fb.group({
            hofzugaengeHinweisschilder: this.fb.group({
                handlungsbedarf: [null as boolean | null],
                umsetzung: [''],
                dokumentenhinweis: [''],
            }),
            bewegungBetriebsgelaende: this.fb.group({
                handlungsbedarf: [null as boolean | null],
                umsetzung: [''],
                dokumentenhinweis: [''],
            }),
            milchuebergabestelle: this.fb.group({
                handlungsbedarf: [null as boolean | null],
                umsetzung: [''],
                dokumentenhinweis: [''],
            }),
            funktionsbereichstrennung: this.fb.group({
                handlungsbedarf: [null as boolean | null],
                umsetzung: [''],
                dokumentenhinweis: [''],
            }),
            trennungTierarten: this.fb.group({
                handlungsbedarf: [null as boolean | null],
                umsetzung: [''],
                dokumentenhinweis: [''],
            }),
            krankenbuchten: this.fb.group({
                handlungsbedarf: [null as boolean | null],
                umsetzung: [''],
                dokumentenhinweis: [''],
            }),
            abkalbebereich: this.fb.group({
                handlungsbedarf: [null as boolean | null],
                umsetzung: [''],
                dokumentenhinweis: [''],
            }),
        }),
        personenUndFahrzeugverkehr: this.fb.group({
            kontaminierteFahrzeuge: this.fb.group({ handlungsbedarf: [null as boolean | null], umsetzung: [''], dokumentenhinweis: [''] }),
            kreuzkontamination: this.fb.group({ handlungsbedarf: [null as boolean | null], umsetzung: [''], dokumentenhinweis: [''] }),
            innerbetrieblicheTiertransportFahrzeuge: this.fb.group({
                handlungsbedarf: [null as boolean | null],
                umsetzung: [''],
                dokumentenhinweis: [''],
            }),
            geraetschaften: this.fb.group({ handlungsbedarf: [null as boolean | null], umsetzung: [''], dokumentenhinweis: [''] }),
            zutrittVonPersonen: this.fb.group({ handlungsbedarf: [null as boolean | null], umsetzung: [''], dokumentenhinweis: [''] }),
            potentiellKontaminiertePersonen: this.fb.group({
                handlungsbedarf: [null as boolean | null],
                umsetzung: [''],
                dokumentenhinweis: [''],
            }),
            verschleppungVonInfektionen: this.fb.group({
                handlungsbedarf: [null as boolean | null],
                umsetzung: [''],
                dokumentenhinweis: [''],
            }),
            betriebsfremdePersonen: this.fb.group({ handlungsbedarf: [null as boolean | null], umsetzung: [''], dokumentenhinweis: [''] }),
            besuchergruppen: this.fb.group({ handlungsbedarf: [null as boolean | null], umsetzung: [''], dokumentenhinweis: [''] }),
            instrumentarium: this.fb.group({ handlungsbedarf: [null as boolean | null], umsetzung: [''], dokumentenhinweis: [''] }),
        }),
        tierverkehr: this.fb.group({
            versatzEinzeltiere: this.fb.group({ handlungsbedarf: [null as boolean | null], umsetzung: [''], dokumentenhinweis: [''] }),
            falltiere: this.fb.group({ handlungsbedarf: [null as boolean | null], umsetzung: [''], dokumentenhinweis: [''] }),
            ungewollteTierkontakte: this.fb.group({ handlungsbedarf: [null as boolean | null], umsetzung: [''], dokumentenhinweis: [''] }),
            treibewegePensionshaltungBetriebsgrenzen: this.fb.group({
                handlungsbedarf: [null as boolean | null],
                umsetzung: [''],
                dokumentenhinweis: [''],
            }),
            tierverkehrZwischenBetrieben: this.fb.group({ handlungsbedarf: [null as boolean | null], umsetzung: [''], dokumentenhinweis: [''] }),
            transportSammelstellen: this.fb.group({ handlungsbedarf: [null as boolean | null], umsetzung: [''], dokumentenhinweis: [''] }),
            ausstellungenAuktionen: this.fb.group({ handlungsbedarf: [null as boolean | null], umsetzung: [''], dokumentenhinweis: [''] }),
            tierverkehrKliniken: this.fb.group({ handlungsbedarf: [null as boolean | null], umsetzung: [''], dokumentenhinweis: [''] }),
            verkehrZuchtmaterial: this.fb.group({ handlungsbedarf: [null as boolean | null], umsetzung: [''], dokumentenhinweis: [''] }),
        }),
        materialien: this.fb.group({
            hygieneFutterTraenke: this.fb.group({ handlungsbedarf: [null as boolean | null], umsetzung: [''], dokumentenhinweis: [''] }),
            verkehrTierausscheidungen: this.fb.group({ handlungsbedarf: [null as boolean | null], umsetzung: [''], dokumentenhinweis: [''] }),
            beweidungJungtiere: this.fb.group({ handlungsbedarf: [null as boolean | null], umsetzung: [''], dokumentenhinweis: [''] }),
            kolostrummanagement: this.fb.group({ handlungsbedarf: [null as boolean | null], umsetzung: [''], dokumentenhinweis: [''] }),
        }),
        ueberwachungTiergesundheit: this.fb.group({
            tierbeobachtung: this.fb.group({ handlungsbedarf: [null as boolean | null], umsetzung: [''], dokumentenhinweis: [''] }),
            produktionsbiologischeDaten: this.fb.group({ handlungsbedarf: [null as boolean | null], umsetzung: [''], dokumentenhinweis: [''] }),
            fachlicheBegleitungTiergesundheitsbesuche: this.fb.group({
                handlungsbedarf: [null as boolean | null],
                umsetzung: [''],
                dokumentenhinweis: [''],
            }),
            hinzuziehenExpertenwissen: this.fb.group({ handlungsbedarf: [null as boolean | null], umsetzung: [''], dokumentenhinweis: [''] }),
            frueherkennungTierseuchenTierkrankheiten: this.fb.group({
                handlungsbedarf: [null as boolean | null],
                umsetzung: [''],
                dokumentenhinweis: [''],
            }),
            weitereMassnahmenInfektionsdruck: this.fb.group({
                handlungsbedarf: [null as boolean | null],
                umsetzung: [''],
                dokumentenhinweis: [''],
            }),
            reinigungDesinfektion: this.fb.group({ handlungsbedarf: [null as boolean | null], umsetzung: [''], dokumentenhinweis: [''] }),
        }),
        mapAnhangParatuberkulose: this.fb.group({
            initialPlan: [false],
            evaluationsNr: [''],
            naechsteSchritte: this.fb.group({
                terminierung: [''],
                einzelmilchproben: [false],
                einzelblutproben: [false],
            }),
            erkennungBestandsinfektion: this.fb.group({
                pflicht31: this.fb.group({
                    serologieAntikoerper: [''],
                    sammelmilchproben: [false],
                    sammelmilchDatum: [''],
                    sammelmilchErgebnis: [''],
                    einzeltierproben: [false],
                    jahre: this.fb.group(this.createInfektionYearGroups()),
                }),
                pflicht32: this.fb.array([
                    this.createDatumErgebnisRow(),
                    this.createDatumErgebnisRow(),
                    this.createDatumErgebnisRow(),
                ]),
            }),
            handlungstabelle: this.fb.array([this.createHandlungRow()]),
            jahreswerte: this.fb.array([this.createParatuberkuloseRow()]),
        }),
    });

    private autosaveSub?: Subscription;
    private clientMismatchRedirectSub?: Subscription;
    private autosaveHandle?: number;
    private pendingAutosaveChanges = 0;
    private pendingSectionIds = new Set<number>();
    private suppressAutosave = false;
    private isLoadingPlan = false;
    isSaving = false;
    bsId: number | null = null;
    statusId: number | null = null;
    /** Kunde des Plans (read_one), Fallback wenn kein aktueller Mandant im LocalStorage passt. */
    planKundeId: number | null = null;
    unterschriftKunde = 0;
    planKuid = '';
    /** Am Plan gespeicherter Tierarzt (wie Biosicherheitsplan Schwein wählbar). */
    tierarztId: number | null = null;
    currentVet?: Tierarzt;
    sketchUploads: Array<{ bsd_id?: number; pdf_id?: number; file?: File; url?: string; dateiname: string; sektion?: string }> = [];
    previewFileName = '';
    previewUrl: SafeResourceUrl | SafeUrl | string = '';
    previewDownloadUrl = '';
    previewIsImage = false;
    previewIsPdf = false;
    private previewObjectUrl?: string;
    readonly infektionsJahre = [
        { key: 'y2022', label: '2022' },
        { key: 'y2023', label: '2023' },
        { key: 'y2024', label: '2024' },
        { key: 'y2025', label: '2025' },
        { key: 'y2026', label: '2026' },
        { key: 'y2027', label: '2027' },
        { key: 'y2028', label: '2028' },
        { key: 'y2029', label: '2029' },
        { key: 'y2030', label: '2030' },
        { key: 'y2031', label: '2031' },
    ];
    mapChartType = ChartType.LineChart;
    mapChartColumns = ['Jahr', '% MAP-positiv'];
    mapChartData: Array<[string, number]> = [];
    mapChartHasData = false;
    mapChartOptions = {
        legend: { position: 'none' },
        hAxis: { title: 'Jahr' },
        vAxis: { title: '% MAP-positiv', minValue: 0 },
        chartArea: { width: '78%', height: '70%' },
        pointSize: 6,
    };

    constructor(
        private readonly fb: FormBuilder,
        public dialog: MatDialog,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly api: KieneBackendApiService,
        private readonly sanitizer: DomSanitizer,
        public readonly localStorageService: LocalStorageService,
        private readonly changeCurrentClientService: ChangeCurrentClientService,
        private readonly messageService: MessageService,
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly pdf: PdfViewerDesktopService,
    ) {}

    ngOnInit(): void {
        this.startAutosave();
        this.registerClientMismatchRedirect();
        const bsIdFromRoute = Number(this.route.snapshot.paramMap.get('bs_id') || 0);
        if (bsIdFromRoute > 0) {
            this.prefillFromCurrentClient();
            this.prefillFromCurrentMandant();
            this.loadPlanById(bsIdFromRoute);
            return;
        }

        const client = this.localStorageService.getCurrentClient();
        if (!client?.kunde_id) {
            this.changeCurrentClientService.openChangeDialog({ nurRinderbetriebe: true }).subscribe({
                next: (c: Client) => {
                    if (c?.kunde_id) {
                        if (!LocalStorageService.isClientRind(c)) {
                            this.messageService.hintMessage(
                                'Ausgewählter Betrieb ist kein Rinder-Betrieb. Bitte wählen Sie einen gültigen Betrieb aus.',
                            );
                            this.router
                                .navigate(['belege/bestandsbesuch'], { queryParams: { tab: 'biosicherheitsplan-rind' } })
                                .catch(() => {});
                            return;
                        }
                        this.ensurePlanRouteForCurrentClient(c);
                    } else {
                        this.router
                            .navigate(['belege/bestandsbesuch'], { queryParams: { tab: 'biosicherheitsplan-rind' } })
                            .catch(() => {});
                    }
                },
            });
            return;
        }

        if (!LocalStorageService.isClientRind(client)) {
            this.messageService.hintMessage(
                'Ausgewählter Betrieb ist kein Rinder-Betrieb. Die Angaben können trotzdem manuell erfasst werden.',
            );
        }
        this.ensurePlanRouteForCurrentClient();
    }

    ngOnDestroy(): void {
        this.clientMismatchRedirectSub?.unsubscribe();
        this.autosaveSub?.unsubscribe();
        if (this.autosaveHandle) {
            window.clearTimeout(this.autosaveHandle);
        }
        this.sketchUploads.forEach(entry => URL.revokeObjectURL(entry.url));
        this.revokePreviewObjectUrl();
    }

    /**
     * Wenn der aktuelle Betrieb gewechselt wird, obwohl ein Plan eines anderen Kunden offen ist:
     * zur Übersicht wechseln (verhindert Speichern im falschen Kontext).
     */
    private registerClientMismatchRedirect(): void {
        this.clientMismatchRedirectSub = this.localStorageService.watchCurrentClient().subscribe((client: Client | null) => {
            const planKunde = this.planKundeId;
            if (planKunde == null || planKunde <= 0) {
                return;
            }
            const currentKunde = client?.kunde_id ?? null;
            if (currentKunde == null || currentKunde !== planKunde) {
                this.messageService.hintMessage(
                    'Der gewählte Betrieb passt nicht zum geöffneten Plan. Es wird zur Übersicht gewechselt.',
                );
                this.router
                    .navigate(['belege/bestandsbesuch'], { queryParams: { tab: 'biosicherheitsplan-rind' } })
                    .catch(() => {});
            }
        });
    }

    /**
     * Nach Erzeugung einer neuen KUID (Sign-Button): KUID im Plan speichern.
     * Ob unterschrieben ist, ergibt sich allein aus kuids.kunde_png (JOIN in read).
     */
    persistKuidToPlan(kuid: string): void {
        const k = (kuid || '').trim();
        if (!k) {
            return;
        }
        this.planKuid = k;
        if (!this.bsId) {
            this.messageService.hintMessage('Bitte erst einen Plan speichern.');
            return;
        }
        if (this.isAlreadySigned()) {
            return;
        }

        this.isSaving = true;
        this.api
            .post(this.apiBaseUrl + 'biosicherheitsplan_rind/update_unterschrift.php', {
                bs_id: this.bsId,
                kuid: k,
            })
            .subscribe({
                next: () => {
                    this.isSaving = false;
                    this.loadPlanById(this.bsId!);
                },
                error: err => {
                    this.isSaving = false;
                    this.messageService.errorMessage('KUID konnte nicht am Plan gespeichert werden.', err);
                },
            });
    }

    /** Nach Schließen des QR-Dialogs: Daten neu laden (PNG kann in kuids gespeichert sein). */
    onSignDialogClosed(): void {
        if (this.bsId) {
            this.loadPlanById(this.bsId);
        }
    }

    setTierarzt(vet: Tierarzt | null): void {
        if (this.isReadOnly()) {
            return;
        }
        const nextTierarztId = vet?.tierarzt_id ?? null;
        // Autocomplete may re-emit the currently selected item on init/rebind.
        // Ignore no-op emissions to avoid unintended forced saves.
        if ((this.tierarztId ?? null) === nextTierarztId) {
            return;
        }
        if (!vet) {
            this.tierarztId = null;
            this.currentVet = undefined;
        } else {
            this.tierarztId = vet.tierarzt_id;
            this.currentVet = vet;
        }
        if (this.isLoadingPlan) {
            return;
        }
        this.savePlan(true);
    }

    private ladeTierarzt(id: number | null | undefined): void {
        if (!this.canReadTierarzt()) {
            this.currentVet = undefined;
            return;
        }
        if (!id) {
            this.currentVet = undefined;
            return;
        }
        const params = new HttpParams().set('tierarzt_id', id);
        this.api.get(this.apiBaseUrl + 'tierarzt/read_one.php', params).subscribe({
            next: (value: Tierarzt) => {
                this.currentVet = value;
            },
            error: err => {
                const errText = `${err?.error?.errortext || err?.error?.message || err?.message || ''}`.toLowerCase();
                const isMissingTierarztPermission =
                    errText.includes('keine berechtigung') && (errText.includes('(1251)') || errText.includes('tierärzte - anzeigen'));
                // Für Nutzer ohne Tierarzt-Recht (z. B. Landwirte) still ignorieren.
                if (isMissingTierarztPermission) {
                    this.currentVet = undefined;
                    return;
                }
                this.messageService.errorMessage('Tierarzt konnte nicht geladen werden.', err);
            },
        });
    }

    private canReadTierarzt(): boolean {
        return this.localStorageService.hasPermission(1251);
    }

    private setCurrentUserAsTierarzt(): void {
        const id = this.localStorageService.getCurrentUser()?.tierarzt_id;
        if (id) {
            this.tierarztId = id;
            this.ladeTierarzt(id);
        }
    }

    abschliessen(): void {
        if (!this.bsId) {
            this.messageService.hintMessage('Bitte warten, bis der Plan vollständig geladen ist.');
            return;
        }
        if (this.statusId === 232 || this.statusId === 250 || this.statusId === 251) {
            this.openLatestAbschlussPdf(this.bsId, () => {
                this.router
                    .navigate(['belege/bestandsbesuch'], { queryParams: { tab: 'biosicherheitsplan-rind' } })
                    .catch(() => {});
            });
            return;
        }
        this.savePlan(true, {
            navigateToUebersichtAfterSuccess: true,
            statusIdForSave: 232,
            openPdfAfterAbschluss: true,
        });
    }

    setBeantragtStatus(status: 231 | 232 | 250 | 251 | 252): void {
        if (!this.bsId) {
            return;
        }
        this.isSaving = true;
        this.api
            .post(this.apiBaseUrl + 'biosicherheitsplan_rind/beantragt.php', {
                bs_id: this.bsId,
                status_id: status,
            })
            .subscribe({
                next: () => {
                    this.statusId = status;
                    this.isSaving = false;
                    this.messageService.infoMessage('Status wurde aktualisiert.');
                    if (this.bsId) {
                        this.loadPlanById(this.bsId);
                    }
                },
                error: err => {
                    this.isSaving = false;
                    this.messageService.errorMessage('Status konnte nicht aktualisiert werden.', err);
                },
            });
    }

    duplicateToOtherClient(): void {
        if (!this.bsId) {
            this.messageService.hintMessage('Bitte zuerst einen Plan speichern.');
            return;
        }

        this.changeCurrentClientService.openChangeDialog({ nurRinderbetriebe: true }).subscribe({
            next: client => {
                if (!client?.kunde_id) {
                    return;
                }

                if (!LocalStorageService.isClientRind(client)) {
                    this.messageService.hintMessage('Der ausgewählte Betrieb ist kein Rinder-Betrieb.');
                    return;
                }

                this.isSaving = true;
                this.api
                    .post(this.apiBaseUrl + 'biosicherheitsplan_rind/duplicate.php', {
                        bs_id: this.bsId,
                        ziel_kunde_id: client.kunde_id,
                    })
                    .subscribe({
                        next: () => {
                            this.isSaving = false;
                            this.messageService.infoMessage('Plan wurde erfolgreich für den gewählten Betrieb kopiert.');
                        },
                        error: err => {
                            this.isSaving = false;
                            this.messageService.errorMessage('Plan konnte nicht kopiert werden.', err);
                        },
                    });
            },
        });
    }

    openTSKDialog(): void {
        const currentClient = this.localStorageService.getCurrentClient();
        const kundeId = currentClient?.kunde_id ?? this.planKundeId;
        if (!kundeId) {
            this.messageService.hintMessage('Bitte zuerst einen Betrieb auswählen.');
            return;
        }

        const input = new EnterValueInput();
        input.addInputValue('TSK - Nummer', 'numeric', this.form.get('tskNummern')?.value || '');
        input.title = 'TSK-Nummer';
        input.text = 'Geben Sie die TSK-Nummer ein.';

        this.dialog
            .open(EnterValueDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: (result: EnterValueResponse) => {
                    if (!result) {
                        return;
                    }

                    const kunde = new Client();
                    kunde.kunde_id = kundeId;
                    kunde.tsk_nummer = result.getValue(0)?.toString() ?? '';

                    this.api.post(this.apiBaseUrl + 'kunde/update_tsk_kundenportal.php', kunde).subscribe({
                        next: (response: Client) => {
                            this.form.patchValue({ tskNummern: response?.tsk_nummer || '' });
                        },
                        error: err => {
                            this.messageService.errorMessage('Kunde konnte nicht gespeichert (TSK - Nummer)', err);
                        },
                    });
                },
            });
    }

    openSection2Info(dialogTemplate: TemplateRef<unknown>): void {
        this.dialog.open(dialogTemplate, {
            width: '980px',
            maxWidth: '95vw',
            maxHeight: '90vh',
            autoFocus: false,
        });
    }

    get paratuberkuloseRows(): FormArray {
        return this.form.get('mapAnhangParatuberkulose.jahreswerte') as FormArray;
    }

    get pflicht32Rows(): FormArray {
        return this.form.get('mapAnhangParatuberkulose.erkennungBestandsinfektion.pflicht32') as FormArray;
    }

    get handlungRows(): FormArray {
        return this.form.get('mapAnhangParatuberkulose.handlungstabelle') as FormArray;
    }

    addParatuberkuloseRow(): void {
        this.paratuberkuloseRows.push(this.createParatuberkuloseRow());
        this.markMapAnhangAsChanged();
    }

    removeParatuberkuloseRow(index: number): void {
        if (this.paratuberkuloseRows.length <= 1) {
            return;
        }
        this.paratuberkuloseRows.removeAt(index);
        this.markMapAnhangAsChanged(true);
    }

    addPflicht32Row(): void {
        this.pflicht32Rows.push(this.createDatumErgebnisRow());
        this.markMapAnhangAsChanged();
    }

    addHandlungRow(): void {
        this.handlungRows.push(this.createHandlungRow());
        this.markMapAnhangAsChanged();
    }

    removeHandlungRow(index: number): void {
        if (this.handlungRows.length <= 1) {
            return;
        }
        this.handlungRows.removeAt(index);
        this.markMapAnhangAsChanged(true);
    }

    private markMapAnhangAsChanged(saveImmediately = false): void {
        const mapAnhangGroup = this.form.get('mapAnhangParatuberkulose');
        mapAnhangGroup?.markAsDirty();
        this.pendingSectionIds.add(8);
        mapAnhangGroup?.updateValueAndValidity({ emitEvent: true });
        if (saveImmediately) {
            this.savePlan(true);
        }
    }

    getParatuberkuloseProzent(rowValue: any): number {
        const getestet = Number(rowValue?.getestet || 0);
        const positiv = Number(rowValue?.positiv || 0);
        if (getestet <= 0 || positiv <= 0) {
            return 0;
        }
        return Number(((positiv / getestet) * 100).toFixed(1));
    }

    openParatuberkulosePreview(dialogTemplate: TemplateRef<unknown>): void {
        this.mapChartData = this.buildParatuberkuloseChartData();
        this.mapChartHasData = this.mapChartData.length > 0;
        this.dialog.open(dialogTemplate, {
            width: '980px',
            maxWidth: '96vw',
            maxHeight: '90vh',
            autoFocus: false,
        });
    }

    openLageplanLegende(dialogTemplate: TemplateRef<unknown>): void {
        this.dialog.open(dialogTemplate, {
            width: '1100px',
            maxWidth: '96vw',
            autoFocus: false,
        });
    }

    openLageplanLegendePopout(): void {
        window.open(
            'assets/biosicherheitsplanschwein/biosicherheitsplanschwein_legende_lageskizze.png',
            '_blank',
            'noopener,noreferrer',
        );
    }

    openSketchFilePicker(fileInput: HTMLInputElement): void {
        fileInput.click();
    }

    onSketchFilesSelected(event: Event): void {
        const input = event.target as HTMLInputElement;
        if (!input.files?.length) {
            return;
        }
        this.addSketchFiles(input.files);
        input.value = '';
    }

    onSketchDragOver(event: DragEvent): void {
        event.preventDefault();
    }

    onSketchDrop(event: DragEvent): void {
        event.preventDefault();
        if (!event.dataTransfer?.files?.length) {
            return;
        }
        this.addSketchFiles(event.dataTransfer.files);
    }

    openSketch(
        entry: { bsd_id?: number; pdf_id?: number; file?: File; url?: string; dateiname: string },
        previewDialog: TemplateRef<unknown>,
    ): void {
        const name = (entry.file?.name || entry.dateiname || '').toLowerCase();
        this.previewFileName = entry.file?.name || entry.dateiname || 'Dokument';
        this.previewIsPdf = name.endsWith('.pdf');
        this.previewIsImage =
            name.endsWith('.png') ||
            name.endsWith('.jpg') ||
            name.endsWith('.jpeg') ||
            name.endsWith('.gif') ||
            name.endsWith('.webp') ||
            name.endsWith('.svg');

        this.revokePreviewObjectUrl();
        const mailOptsPdf =
            this.kundeIdForSign != null && this.kundeIdForSign > 0
                ? { email: { sende_mail: true, kunde_id: this.kundeIdForSign } }
                : undefined;
        if (entry.bsd_id && this.previewIsPdf) {
            let params = new HttpParams().set('bsd_id', String(entry.bsd_id));
            if (entry.pdf_id) {
                params = params.set('pdf_id', String(entry.pdf_id));
            }
            const input = new PdfViewerDialogInput(
                'biosicherheitsplan_rind_dokuments/read_or_mail_pdf.php',
                params,
                this.previewFileName,
                mailOptsPdf,
            );
            this.pdf.openPdfViewer(input).subscribe();
            return;
        }

        if (entry.bsd_id) {
            const params = new HttpParams().set('bsd_id', String(entry.bsd_id));
            this.api.getBlob(this.apiBaseUrl + 'biosicherheitsplan_rind_dokuments/read_or_mail_pdf.php', params).subscribe({
                next: async (blob: Blob) => {
                    const normalizedBlob = this.normalizePreviewBlob(blob, this.previewFileName);
                    const kind = await this.detectBlobKind(normalizedBlob);
                    if (kind === 'pdf') {
                        const input = new PdfViewerDialogInput(
                            'biosicherheitsplan_rind_dokuments/read_or_mail_pdf.php',
                            new HttpParams().set('bsd_id', String(entry.bsd_id)),
                            this.previewFileName,
                            mailOptsPdf,
                        );
                        this.pdf.openPdfViewer(input).subscribe();
                        return;
                    }
                    if (kind === 'image') {
                        this.previewIsImage = true;
                        this.previewIsPdf = false;
                    }
                    this.previewObjectUrl = URL.createObjectURL(normalizedBlob);
                    this.previewDownloadUrl = this.previewObjectUrl;
                    if (this.previewIsPdf) {
                        this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.previewObjectUrl);
                    } else if (this.previewIsImage) {
                        this.previewUrl = this.sanitizer.bypassSecurityTrustUrl(this.previewObjectUrl);
                    } else {
                        this.previewUrl = this.previewObjectUrl;
                    }
                    this.openSketchPreviewDialog(previewDialog);
                },
                error: async (err: HttpErrorResponse) => {
                    const detail = await this.extractBlobErrorMessage(err);
                    this.messageService.errorMessage(
                        detail
                            ? `Dokument-Vorschau konnte nicht geladen werden: ${detail}`
                            : 'Dokument-Vorschau konnte nicht geladen werden.',
                        null,
                    );
                },
            });
            return;
        }

        const sourceUrl = entry.url || '';
        this.previewDownloadUrl = sourceUrl;
        if (this.previewIsPdf) {
            this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(sourceUrl);
        } else if (this.previewIsImage) {
            this.previewUrl = this.sanitizer.bypassSecurityTrustUrl(sourceUrl);
        } else {
            this.previewUrl = sourceUrl;
        }
        this.openSketchPreviewDialog(previewDialog);
    }

    private openSketchPreviewDialog(previewDialog: TemplateRef<unknown>): void {
        this.dialog
            .open(previewDialog, {
                width: '1100px',
                maxWidth: '96vw',
                maxHeight: '92vh',
                autoFocus: false,
            })
            .afterClosed()
            .subscribe(() => this.revokePreviewObjectUrl());
    }

    private revokePreviewObjectUrl(): void {
        if (!this.previewObjectUrl) {
            return;
        }
        URL.revokeObjectURL(this.previewObjectUrl);
        this.previewObjectUrl = undefined;
    }

    removeSketch(index: number): void {
        const item = this.sketchUploads[index];
        if (!item) {
            return;
        }
        if (item.bsd_id) {
            this.api.post(this.apiBaseUrl + 'biosicherheitsplan_rind_dokuments/delete.php', { bsd_id: item.bsd_id }).subscribe({
                next: () => {
                    this.sketchUploads.splice(index, 1);
                },
                error: err => {
                    this.messageService.errorMessage('Dokument konnte nicht gelöscht werden.', err);
                },
            });
        } else {
            if (item.url) {
                URL.revokeObjectURL(item.url);
            }
            this.sketchUploads.splice(index, 1);
        }
    }

    private addSketchFiles(fileList: FileList): void {
        if (!this.bsId) {
            this.messageService.hintMessage('Bitte erst einmal im Formular etwas speichern.');
            this.savePlan(true);
            return;
        }
        const incoming = Array.from(fileList);
        const existingKeys = new Set(this.sketchUploads.map(entry => `${entry.dateiname}`));
        for (const file of incoming) {
            const key = `${file.name}`;
            if (!existingKeys.has(key)) {
                this.uploadSketch(file);
                existingKeys.add(key);
            }
        }
    }

    private uploadSketch(file: File): void {
        if (!this.bsId) {
            return;
        }
        const fd = new FormData();
        fd.set('bs_id', this.bsId.toString());
        fd.set('sektion', 'lageplan');
        fd.set('dateiname', file.name);
        fd.append('dokument', file);
        const options = { headers: new HttpHeaders('Phito-Type: fileupload'), reportProgress: true };
        this.api.postFormData(this.apiBaseUrl + 'biosicherheitsplan_rind_dokuments/create.php', fd, options).subscribe({
            next: (response: any) => {
                const createdId = Number(response?.bsd_id || 0);
                if (createdId > 0 && !this.sketchUploads.some(entry => Number(entry?.bsd_id || 0) === createdId)) {
                    this.sketchUploads.unshift({
                        bsd_id: createdId,
                        pdf_id: Number(response?.pdf_id || 0) || undefined,
                        dateiname: file.name,
                        sektion: 'lageplan',
                    });
                }
                this.messageService.infoMessage('Dokument wurde erfolgreich hochgeladen.');
                this.loadSketchUploads();
            },
            error: err => {
                const detail = err?.error?.errortext || err?.error?.fehler;
                this.messageService.errorMessage(
                    detail ? `Dokument konnte nicht hochgeladen werden (${detail})` : 'Dokument konnte nicht hochgeladen werden.',
                    err,
                );
            },
        });
    }

    private createPersonGroup(): FormGroup {
        return this.fb.group({
            name: [''],
            vorname: [''],
            plz: [''],
            ort: [''],
            strasse: [''],
            hausnummer: [''],
            telefon: [''],
            email: ['', [Validators.email]],
        });
    }

    private prefillFromCurrentClient(): void {
        const currentClient = this.localStorageService.getCurrentClient();
        if (!currentClient) {
            return;
        }

        if (!LocalStorageService.isClientRind(currentClient)) {
            this.messageService.hintMessage(
                'Der aktuell ausgewählte Betrieb ist kein Rinder-Betrieb. Die Angaben können trotzdem manuell erfasst werden.',
            );
        }

        this.prefillFromClient(currentClient);
    }

    private prefillFromClient(client: Client): void {
        const [name = '', vorname = ''] = (client.bezeichnung_final || '').split(' ');
        const strasse = client.strasse_final || '';
        const [strasseOhneHausnummer, hausnummer = ''] = this.splitStreetAndHouseNumber(strasse);

        const payload: BiosicherheitsplanRindSection1 = {
            besteuerung: null,
            planDatum: null,
            tskNummern: client.tsk_nummer || '',
            registriernummern: client.vvvo || '',
            betrieb: {
                name,
                vorname,
                plz: client.plz_final || '',
                ort: client.ort_final || '',
                strasse: strasseOhneHausnummer,
                hausnummer,
                telefon: client.telefon_1 || '',
                email: client.email || '',
            },
            verantwortlichePerson: {
                name: '',
                vorname: '',
                plz: '',
                ort: '',
                strasse: '',
                hausnummer: '',
                telefon: '',
                email: '',
            },
        };

        this.patchWithoutAutosave(() => this.form.patchValue(payload));
    }

    private prefillFromCurrentMandant(): void {
        const mandant = this.localStorageService.getCurrentMandant();
        if (!mandant) {
            return;
        }

        const anschrift = [mandant.strasse, mandant.plz, mandant.ort].filter(Boolean).join(', ');
        const tieraerztlicheBetreuungGroup = this.form.get('tieraerztlicheBetreuung');
        if (!tieraerztlicheBetreuungGroup) {
            return;
        }

        this.patchWithoutAutosave(() =>
            tieraerztlicheBetreuungGroup.patchValue({
            name: mandant.bezeichnung || '',
            anschrift,
            vvvoNr: mandant.vvvo || '',
            }),
        );
    }

    private splitStreetAndHouseNumber(value: string): [string, string] {
        const trimmed = (value || '').trim();
        if (!trimmed) {
            return ['', ''];
        }

        const match = trimmed.match(/^(.*?)(\s+\d+[\w/-]*)$/);
        if (!match) {
            return [trimmed, ''];
        }

        return [match[1].trim(), match[2].trim()];
    }

    private startAutosave(): void {
        this.autosaveSub = this.form.valueChanges.subscribe(() => {
            if (this.suppressAutosave || this.isLoadingPlan || this.isReadOnly()) {
                return;
            }
            this.pendingAutosaveChanges += 1;
            this.collectDirtySections();
            if (this.autosaveHandle) {
                window.clearTimeout(this.autosaveHandle);
            }
            // Batchweise speichern: mehrere Änderungen sammeln und dann zusammen speichern.
            this.autosaveHandle = window.setTimeout(() => this.savePlan(), 1500);

            if (this.pendingAutosaveChanges >= 10) {
                this.savePlan();
            }
        });
    }

    /**
     * Ohne bs_id in der Route: Plan per API anlegen (INSERT) oder bestehende bs_id ermitteln,
     * dann Navigation auf /belege/biosicherheitsplanrind/{bs_id} (replaceUrl), damit die URL nicht dauerhaft „…/0“ bleibt.
     */
    private ensurePlanRouteForCurrentClient(client?: Client): void {
        const currentClient = client || this.localStorageService.getCurrentClient();
        if (!currentClient?.kunde_id) {
            return;
        }

        this.isLoadingPlan = true;
        this.api
            .post(this.apiBaseUrl + 'biosicherheitsplan_rind/ensure_plan.php', { kunde_id: currentClient.kunde_id })
            .subscribe({
                next: (res: { bs_id?: number; already_exists?: boolean }) => {
                    this.isLoadingPlan = false;
                    if (!res?.bs_id) {
                        this.messageService.errorMessage('Plan konnte nicht angelegt oder geladen werden.', null);
                        return;
                    }
                    if (res.already_exists) {
                        this.messageService.hintMessage(
                            'Für diesen Kunden existiert bereits ein Biosicherheitsplan. Der bestehende Plan wird geöffnet.',
                        );
                    }
                    bspRindSetSkipPlanOeffnenBestaetigung(res.bs_id);
                    this.planKundeId = currentClient.kunde_id ?? null;
                    this.router
                        .navigate(['belege/biosicherheitsplanrind/' + res.bs_id], { replaceUrl: true })
                        .catch(() => {});
                },
                error: err => {
                    this.isLoadingPlan = false;
                    this.messageService.errorMessage('Biosicherheitsplan konnte nicht angelegt werden.', err);
                },
            });
    }

    private loadPlanById(bsId: number): void {
        this.isLoadingPlan = true;
        this.api.post(this.apiBaseUrl + 'biosicherheitsplan_rind/read_one.php', { bs_id: bsId }).subscribe({
            next: (response: any) => {
                this.isLoadingPlan = false;
                if (!response?.bs_id) {
                    return;
                }
                this.bsId = response.bs_id;
                this.planKundeId = response.kunde_id ?? null;
                this.statusId = Number(response.status_id || 231);
                this.unterschriftKunde = Number(response.unterschrift_kunde || 0);
                this.planKuid = response.kuid || '';
                this.tierarztId = response.tierarzt_id ?? null;
                this.syncReadOnlyState();
                if (this.tierarztId && this.canReadTierarzt()) {
                    this.ladeTierarzt(this.tierarztId);
                } else if (this.localStorageService.currentUserIsVet() && this.canReadTierarzt()) {
                    this.setCurrentUserAsTierarzt();
                } else {
                    this.currentVet = undefined;
                }
                this.patchFormFromSectionPayloads(response);
                this.loadSketchUploads();
                if (
                    this.isReadOnly() &&
                    this.localStorageService.hasPermission(110025) &&
                    !this.consumeSkipPlanOeffnenBestaetigung(response.bs_id)
                ) {
                    this.fragePlanOeffnenBestaetigung();
                }
            },
            error: err => {
                this.isLoadingPlan = false;
                this.messageService.errorMessage('Biosicherheitsplan konnte nicht geladen werden.', err);
            },
        });
    }

    /** Nur bei schreibgeschütztem Plan (abgeschlossen / TSK), nicht bei Status „erstellt“ (231). */
    private fragePlanOeffnenBestaetigung(): void {
        if (!this.localStorageService.hasPermission(110025)) {
            return;
        }
        const input = new ConfirmDialogInput();
        input.headline = 'Plan öffnen';
        input.text =
            'Dieser Biosicherheitsplan ist nicht mehr in Bearbeitung. Möchten Sie ihn zur Ansicht öffnen?';
        input.okButton = 'Ja';
        input.cancelButton = 'Abbrechen';
        this.dialog
            .open(ConfirmDialogComponent, { data: input })
            .afterClosed()
            .subscribe((response: ConfirmDialogResult) => {
                if (response?.ok && response?.confirmed) {
                    // Beim aktiven Öffnen den Plan wieder in "erstellt" setzen.
                    this.savePlan(true, {
                        statusIdForSave: 231,
                        abschlussOnly: true,
                        allowWhenReadOnly: true,
                    });
                    return;
                }
                if (!response?.ok || !response?.confirmed) {
                    this.router
                        .navigate(['belege/bestandsbesuch'], { queryParams: { tab: 'biosicherheitsplan-rind' } })
                        .catch(() => {});
                }
            });
    }

    /** Einmal Skip nach interner Navigation (siehe `bspRindSetSkipPlanOeffnenBestaetigung`). */
    private consumeSkipPlanOeffnenBestaetigung(bsId: number): boolean {
        const v = sessionStorage.getItem(BSP_RIND_SKIP_PLAN_OEFFNEN_KEY);
        if (v != null && v === String(bsId)) {
            sessionStorage.removeItem(BSP_RIND_SKIP_PLAN_OEFFNEN_KEY);
            return true;
        }
        return false;
    }

    private savePlan(
        force = false,
        options?: {
            navigateToUebersichtAfterSuccess?: boolean;
            statusIdForSave?: number;
            abschlussOnly?: boolean;
            openPdfAfterAbschluss?: boolean;
            allowWhenReadOnly?: boolean;
        },
    ): void {
        if (this.isReadOnly() && !options?.allowWhenReadOnly) {
            return;
        }
        if (!force && (this.isLoadingPlan || this.suppressAutosave || this.isReadOnly())) {
            return;
        }
        const currentClient = this.localStorageService.getCurrentClient();
        const kundeId = currentClient?.kunde_id ?? this.planKundeId;
        if (!kundeId) {
            this.messageService.hintMessage(
                'Speichern nicht möglich: Kein Betrieb (Kunde) am Plan. Bitte wählen Sie den Betrieb aus oder öffnen Sie den Plan aus der Übersicht.',
            );
            return;
        }
        if (this.autosaveHandle) {
            window.clearTimeout(this.autosaveHandle);
            this.autosaveHandle = undefined;
        }
        this.pendingAutosaveChanges = 0;

        const sectionPayloads = this.buildSectionPayloads();
        if (!options?.abschlussOnly) {
            this.collectDirtySections();
        } else {
            this.pendingSectionIds.clear();
        }
        const statusForPayload = options?.statusIdForSave ?? this.statusId ?? 231;
        const payload = {
            bs_id: this.bsId || 0,
            kunde_id: kundeId,
            tierarzt_id: this.tierarztId ?? null,
            status_id: statusForPayload,
        } as any;

        if (!options?.abschlussOnly) {
            if (this.pendingSectionIds.has(1)) payload.data_json_1 = JSON.stringify(sectionPayloads.section1);
            if (this.pendingSectionIds.has(2)) payload.data_json_2 = JSON.stringify(sectionPayloads.section2);
            if (this.pendingSectionIds.has(3)) payload.data_json_3 = JSON.stringify(sectionPayloads.section3);
            if (this.pendingSectionIds.has(4)) payload.data_json_4 = JSON.stringify(sectionPayloads.section4);
            if (this.pendingSectionIds.has(5)) payload.data_json_5 = JSON.stringify(sectionPayloads.section5);
            if (this.pendingSectionIds.has(6)) payload.data_json_6 = JSON.stringify(sectionPayloads.section6);
            if (this.pendingSectionIds.has(7)) payload.data_json_7 = JSON.stringify(sectionPayloads.section7);
            if (this.pendingSectionIds.has(8)) payload.data_json_8 = JSON.stringify(sectionPayloads.section8);
            // Fallback payload for initial create only.
            // On existing plans, sending section1 without dirty markers can overwrite stored data.
            if (Object.keys(payload).length <= 6 && !this.bsId) {
                payload.data_json_1 = JSON.stringify(sectionPayloads.section1);
            }
        }

        this.isSaving = true;
        this.api.post(this.apiBaseUrl + 'biosicherheitsplan_rind/update.php', payload).subscribe({
            next: (response: any) => {
                this.isSaving = false;
                if (response?.bs_id) {
                    this.bsId = response.bs_id;
                }
                if (response?.status_id != null && response.status_id !== '') {
                    this.statusId = Number(response.status_id);
                } else if (options?.statusIdForSave != null) {
                    this.statusId = options.statusIdForSave;
                }
                this.syncReadOnlyState();
                this.pendingSectionIds.clear();
                this.form.markAsPristine();
                const navigateToOverview = () => {
                    if (options?.navigateToUebersichtAfterSuccess) {
                        this.router
                            .navigate(['belege/bestandsbesuch'], {
                                queryParams: { tab: 'biosicherheitsplan-rind' },
                            })
                            .catch(() => {});
                    }
                };

                if (options?.openPdfAfterAbschluss && this.bsId) {
                    this.openLatestAbschlussPdf(this.bsId, navigateToOverview);
                } else {
                    navigateToOverview();
                }
            },
            error: err => {
                this.isSaving = false;
                this.messageService.errorMessage('Biosicherheitsplan konnte nicht gespeichert werden.', err);
            },
        });
    }

    private openLatestAbschlussPdf(bsId: number, onDone?: () => void): void {
        this.api.post(this.apiBaseUrl + 'biosicherheitsplan_rind_dokuments/read.php', { bs_id: bsId }).subscribe({
            next: (rowsResponse: any) => {
                const rows = this.extractRows(rowsResponse);
                const docs = (rows || []).filter(r => r?.sektion === 'abschluss_auto');
                docs.sort((a, b) => Number(b?.bsd_id || 0) - Number(a?.bsd_id || 0));
                const latest = docs[0];
                if (latest?.bsd_id) {
                    const kid = this.kundeIdForSign;
                    const input = new PdfViewerDialogInput(
                        'biosicherheitsplan_rind_dokuments/read_or_mail_pdf.php',
                        new HttpParams().set('bs_id', String(bsId)),
                        'Bio-Sicherheitsplan Rind ' + bsId,
                        kid != null && kid > 0 ? { email: { sende_mail: true, kunde_id: kid } } : undefined,
                    );
                    this.pdf.openPdfViewer(input).subscribe({ next: () => onDone?.() });
                    return;
                } else {
                    this.messageService.hintMessage('Abschluss-PDF wurde erstellt, aber konnte nicht automatisch geöffnet werden.');
                }
                onDone?.();
            },
            error: () => {
                this.messageService.hintMessage('Abschluss-PDF wurde erstellt, konnte aber nicht geladen werden.');
                onDone?.();
            },
        });
    }

    getStatusLabel(): string {
        switch (this.statusId) {
            case 232:
                return 'Abgeschlossen';
            case 250:
                return 'TSK beantragt';
            case 251:
                return 'TSK bezahlt';
            default:
                return 'In Bearbeitung';
        }
    }

    isReadOnly(): boolean {
        if (this.statusId === 232 || this.statusId === 250 || this.statusId === 251) {
            return true;
        }
        return !this.localStorageService.hasPermission(110022);
    }

    private syncReadOnlyState(): void {
        if (this.isReadOnly()) {
            this.form.disable({ emitEvent: false });
        } else {
            this.form.enable({ emitEvent: false });
        }
    }

    isAlreadySigned(): boolean {
        return this.unterschriftKunde > 0;
    }

    get signButtonLabel(): string {
        return this.isAlreadySigned() ? 'Bereits unterschrieben' : 'Unterschreiben';
    }

    /** Für Sign-Panel: gewählter Plan-Tierarzt, sonst Tierarzt des angemeldeten Benutzers. */
    get tierarztIdForSign(): number | undefined {
        const t = this.tierarztId ?? this.localStorageService.getCurrentUser()?.tierarzt_id;
        return t != null && t > 0 ? t : undefined;
    }

    /** Für Sign-Panel: aktueller Kunde, sonst Kunde des geladenen Plans. */
    get kundeIdForSign(): number | undefined {
        const k = this.localStorageService.getCurrentClient()?.kunde_id ?? this.planKundeId;
        return k != null && k > 0 ? k : undefined;
    }

    private patchWithoutAutosave(action: () => void): void {
        this.suppressAutosave = true;
        action();
        this.suppressAutosave = false;
    }

    private collectDirtySections(): void {
        if (
            this.isAnyDirty([
                'besteuerung',
                'planDatum',
                'tskNummern',
                'registriernummern',
                'betrieb',
                'verantwortlichePerson',
                'angabenBetrieb',
                'tieraerztlicheBetreuung',
                'tierhaltung',
                'risikofaktorenLage',
            ])
        ) {
            this.pendingSectionIds.add(1);
        }
        if (this.isAnyDirty(['kenntnisseSensibilisierungUnterweisungen'])) this.pendingSectionIds.add(2);
        if (this.isAnyDirty(['baulicheGegebenheiten'])) this.pendingSectionIds.add(3);
        if (this.isAnyDirty(['personenUndFahrzeugverkehr'])) this.pendingSectionIds.add(4);
        if (this.isAnyDirty(['tierverkehr'])) this.pendingSectionIds.add(5);
        if (this.isAnyDirty(['materialien'])) this.pendingSectionIds.add(6);
        if (this.isAnyDirty(['ueberwachungTiergesundheit'])) this.pendingSectionIds.add(7);
        if (this.isAnyDirty(['mapAnhangParatuberkulose'])) this.pendingSectionIds.add(8);
    }

    private isAnyDirty(paths: string[]): boolean {
        return paths.some(path => !!this.form.get(path)?.dirty);
    }

    private buildSectionPayloads(): {
        section1: any;
        section2: any;
        section3: any;
        section4: any;
        section5: any;
        section6: any;
        section7: any;
        section8: any;
    } {
        const value = this.form.getRawValue();
        return {
            section1: {
                besteuerung: value.besteuerung,
                planDatum: this.formatPlanDatum(value.planDatum),
                tskNummern: value.tskNummern,
                registriernummern: value.registriernummern,
                betrieb: value.betrieb,
                verantwortlichePerson: value.verantwortlichePerson,
                angabenBetrieb: value.angabenBetrieb,
                tieraerztlicheBetreuung: value.tieraerztlicheBetreuung,
                tierhaltung: value.tierhaltung,
                risikofaktorenLage: value.risikofaktorenLage,
            },
            section2: {
                kenntnisseSensibilisierungUnterweisungen: value.kenntnisseSensibilisierungUnterweisungen,
            },
            section3: {
                baulicheGegebenheiten: value.baulicheGegebenheiten,
            },
            section4: {
                personenUndFahrzeugverkehr: value.personenUndFahrzeugverkehr,
            },
            section5: {
                tierverkehr: value.tierverkehr,
            },
            section6: {
                materialien: value.materialien,
            },
            section7: {
                ueberwachungTiergesundheit: value.ueberwachungTiergesundheit,
            },
            section8: {
                mapAnhangParatuberkulose: value.mapAnhangParatuberkulose,
            },
        };
    }

    private createParatuberkuloseRow(): FormGroup {
        return this.fb.group({
            jahr: [''],
            getestet: [null],
            positiv: [null],
        });
    }

    private createDatumErgebnisRow(): FormGroup {
        return this.fb.group({
            datum: [''],
            ergebnis: [''],
        });
    }

    private createHandlungRow(): FormGroup {
        return this.fb.group({
            nr: [''],
            schwachstelle: [''],
            handlungsempfehlung: [''],
            erledigtUnterlagen: [''],
        });
    }

    private createInfektionYearGroups(): Record<string, FormGroup> {
        const groups: Record<string, FormGroup> = {};
        const yearKeys = ['y2022', 'y2023', 'y2024', 'y2025', 'y2026', 'y2027', 'y2028', 'y2029', 'y2030', 'y2031'];
        for (const key of yearKeys) {
            groups[key] = this.fb.group({
                bekannteMapReagenten: [''],
                entfernteMapReagenten: [''],
                verbliebeneMapReagenten: [''],
                datumStatuskontrolle: [''],
                negFraglich: [''],
                pos: [''],
                mapReagenten: [''],
                anteilMapReagenten: [''],
                anzahlTiereMapPos: [''],
                anzahlZuchtTiere24Mon: [''],
            });
        }
        return groups;
    }

    private buildParatuberkuloseChartData(): Array<[string, number]> {
        const rows = (this.paratuberkuloseRows?.value || []) as Array<{
            jahr: string | number;
            getestet: number;
            positiv: number;
        }>;
        return rows
            .filter(r => r?.jahr !== null && r?.jahr !== undefined && `${r.jahr}`.trim() !== '')
            .map(r => ({
                jahr: String(r.jahr).trim(),
                prozent: this.getParatuberkuloseProzent(r),
            }))
            .filter(r => /^\d{4}$/.test(r.jahr) && Number.isFinite(r.prozent))
            .sort((a, b) => Number(a.jahr) - Number(b.jahr))
            .map(r => [r.jahr, r.prozent]);
    }

    private patchFormFromSectionPayloads(response: any): void {
        const merged: any = {};
        const keys = ['data_json_1', 'data_json_2', 'data_json_3', 'data_json_4', 'data_json_5', 'data_json_6', 'data_json_7', 'data_json_8'];
        for (const key of keys) {
            const raw = response?.[key];
            if (!raw) {
                continue;
            }
            try {
                const parsed = JSON.parse(raw);
                Object.assign(merged, parsed);
            } catch {
                // ignore invalid json chunk
            }
        }

        if (Object.keys(merged).length > 0) {
            this.normalizeBesteuerung(merged);
            this.normalizePlanDatum(merged);
            this.hydrateMapAnhangArrays(merged);
            this.patchWithoutAutosave(() => this.form.patchValue(merged));
            return;
        }

        if (response?.data_json) {
            try {
                const parsed = JSON.parse(response.data_json);
                this.normalizeBesteuerung(parsed);
                this.normalizePlanDatum(parsed);
                this.hydrateMapAnhangArrays(parsed);
                this.patchWithoutAutosave(() => this.form.patchValue(parsed));
            } catch {
                this.messageService.hintMessage('Gespeicherte Daten konnten nicht vollständig geladen werden.');
            }
        }
    }

    /** Speichert das Plandatum als lokales YYYY-MM-DD, ohne UTC-Verschiebung. */
    private formatPlanDatum(value: unknown): string {
        const date = this.parsePlanDatum(value);
        if (!date) {
            return '';
        }
        const month = `${date.getMonth() + 1}`.padStart(2, '0');
        const day = `${date.getDate()}`.padStart(2, '0');
        return `${date.getFullYear()}-${month}-${day}`;
    }

    private parsePlanDatum(value: unknown): Date | null {
        if (value == null || value === '') {
            return null;
        }
        if (value instanceof Date) {
            return Number.isNaN(value.getTime()) ? null : value;
        }
        const raw = String(value).trim();
        const ymd = /^(\d{4})-(\d{2})-(\d{2})/.exec(raw);
        if (ymd) {
            return new Date(+ymd[1], +ymd[2] - 1, +ymd[3], 12, 0, 0);
        }
        const de = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec(raw);
        if (de) {
            return new Date(+de[3], +de[2] - 1, +de[1], 12, 0, 0);
        }
        const parsed = new Date(raw);
        return Number.isNaN(parsed.getTime()) ? null : parsed;
    }

    private normalizePlanDatum(payload: Record<string, unknown>): void {
        if (!('planDatum' in payload)) {
            return;
        }
        payload['planDatum'] = this.parsePlanDatum(payload['planDatum']);
    }

    private normalizeBesteuerung(payload: Record<string, unknown>): void {
        const besteuerung = payload['besteuerung'];
        if (besteuerung === 'optierend' || besteuerung === 'pauschal') {
            delete payload['besteuerungOptierend'];
            delete payload['besteuerungPauschal'];
            return;
        }
        if (payload['besteuerungPauschal']) {
            payload['besteuerung'] = 'pauschal';
        } else if (payload['besteuerungOptierend']) {
            payload['besteuerung'] = 'optierend';
        } else {
            payload['besteuerung'] = null;
        }
        delete payload['besteuerungOptierend'];
        delete payload['besteuerungPauschal'];
    }

    private hydrateMapAnhangArrays(payload: any): void {
        const map = payload?.mapAnhangParatuberkulose;
        if (!map) {
            return;
        }
        this.syncFormArrayWithData(this.paratuberkuloseRows, map?.jahreswerte, () => this.createParatuberkuloseRow());
        this.syncFormArrayWithData(this.pflicht32Rows, map?.erkennungBestandsinfektion?.pflicht32, () => this.createDatumErgebnisRow());
        this.syncFormArrayWithData(this.handlungRows, map?.handlungstabelle, () => this.createHandlungRow());
    }

    private syncFormArrayWithData(formArray: FormArray, rows: any[], createRow: () => FormGroup): void {
        if (!Array.isArray(rows) || rows.length === 0) {
            return;
        }
        while (formArray.length < rows.length) {
            formArray.push(createRow());
        }
        while (formArray.length > rows.length && formArray.length > 1) {
            formArray.removeAt(formArray.length - 1);
        }
    }

    private loadSketchUploads(): void {
        if (!this.bsId) {
            this.sketchUploads = [];
            return;
        }
        this.api.post(this.apiBaseUrl + 'biosicherheitsplan_rind_dokuments/read.php', { bs_id: this.bsId }).subscribe({
            next: (rowsResponse: any) => {
                const rows = this.extractRows(rowsResponse);
                this.sketchUploads = (rows || [])
                    .filter(r => r?.sektion === 'lageplan')
                    .map(r => ({
                        bsd_id: r.bsd_id,
                        pdf_id: r.pdf_id,
                        dateiname: r.dateiname || `Dokument ${r.bsd_id}`,
                        sektion: r.sektion,
                    }));
            },
            error: () => {
                this.sketchUploads = [];
            },
        });
    }

    private extractRows(rowsResponse: any): any[] {
        if (Array.isArray(rowsResponse)) {
            return rowsResponse;
        }
        if (Array.isArray(rowsResponse?.records)) {
            return rowsResponse.records;
        }
        return [];
    }

    private normalizePreviewBlob(blob: Blob, fileName: string): Blob {
        const lower = (fileName || '').toLowerCase();
        let forcedType = '';
        if (lower.endsWith('.pdf')) {
            forcedType = 'application/pdf';
        } else if (lower.endsWith('.png')) {
            forcedType = 'image/png';
        } else if (lower.endsWith('.jpg') || lower.endsWith('.jpeg')) {
            forcedType = 'image/jpeg';
        } else if (lower.endsWith('.gif')) {
            forcedType = 'image/gif';
        } else if (lower.endsWith('.webp')) {
            forcedType = 'image/webp';
        } else if (lower.endsWith('.svg')) {
            forcedType = 'image/svg+xml';
        }
        if (!forcedType || (blob?.type || '').toLowerCase() === forcedType) {
            return blob;
        }
        return new Blob([blob], { type: forcedType });
    }

    private async detectBlobKind(blob: Blob): Promise<'pdf' | 'image' | 'other'> {
        const type = (blob?.type || '').toLowerCase();
        if (type.startsWith('application/pdf')) {
            return 'pdf';
        }
        if (type.startsWith('image/')) {
            return 'image';
        }

        try {
            const buf = await blob.arrayBuffer();
            const bytes = new Uint8Array(buf.slice(0, 16));
            // %PDF
            if (bytes.length >= 4 && bytes[0] === 0x25 && bytes[1] === 0x50 && bytes[2] === 0x44 && bytes[3] === 0x46) {
                return 'pdf';
            }
            // PNG
            if (
                bytes.length >= 8 &&
                bytes[0] === 0x89 &&
                bytes[1] === 0x50 &&
                bytes[2] === 0x4e &&
                bytes[3] === 0x47 &&
                bytes[4] === 0x0d &&
                bytes[5] === 0x0a &&
                bytes[6] === 0x1a &&
                bytes[7] === 0x0a
            ) {
                return 'image';
            }
            // JPEG
            if (bytes.length >= 3 && bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff) {
                return 'image';
            }
            // GIF
            if (bytes.length >= 4 && bytes[0] === 0x47 && bytes[1] === 0x49 && bytes[2] === 0x46 && bytes[3] === 0x38) {
                return 'image';
            }
            // WEBP (RIFF....WEBP)
            if (
                bytes.length >= 12 &&
                bytes[0] === 0x52 &&
                bytes[1] === 0x49 &&
                bytes[2] === 0x46 &&
                bytes[3] === 0x46 &&
                bytes[8] === 0x57 &&
                bytes[9] === 0x45 &&
                bytes[10] === 0x42 &&
                bytes[11] === 0x50
            ) {
                return 'image';
            }
            const textStart = new TextDecoder().decode(buf.slice(0, Math.min(512, buf.byteLength))).trim().toLowerCase();
            if (textStart.includes('<svg')) {
                return 'image';
            }
        } catch {
            return 'other';
        }
        return 'other';
    }

    private async extractBlobErrorMessage(err: HttpErrorResponse): Promise<string> {
        const payload = err?.error;
        if (!payload) {
            return '';
        }
        if (typeof payload === 'string') {
            return payload;
        }
        if (payload instanceof Blob) {
            try {
                const text = await payload.text();
                const trimmed = (text || '').trim();
                if (!trimmed) {
                    return '';
                }
                try {
                    const json = JSON.parse(trimmed);
                    return json?.errortext || json?.message || trimmed;
                } catch {
                    return trimmed;
                }
            } catch {
                return '';
            }
        }
        if (typeof payload === 'object') {
            return payload?.errortext || payload?.message || '';
        }
        return '';
    }
}
